import { useTranslation } from "react-i18next";
import "./landing-pv-section3.scss";

export const usePvSection3 = () => {
  const { t } = useTranslation();

  return { t };
};
